import {BrandDetailsProvider} from '@/pages/(shared)/brands/detail/providers/brandDetailsProvider';

import BrandDetails from './components/brandDetails';

function BrandDetailsPage() {
  return (
    <BrandDetailsProvider>
      <BrandDetails />;
    </BrandDetailsProvider>
  );
}

export default BrandDetailsPage;
